import React from 'react'
import styled from 'styled-components'
import { ChevronRight } from 'react-bootstrap-icons'

const Style = styled.div`
  #dialogs {
    ul {
      list-style: disk;
      padding-top: 0px;
    }
    #link {
      color: #162941;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      text-decoration: underline !important;
    }
    padding: 16px 16px 16px 16px;
    margin: 0 0 16px 0;
    background: #f6f8f9;
    border-radius: 6px;
    li {
      display: block;
      list-style: disc !important;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #3c585f;
    }

    p {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      margin-bottom: 10px;
      color: #3c585f;
    }
  }
  width: inherit;
  .center {
    flex: 1;
  }
  .place {
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 25px;
    color: #56787d;
  }
  .destination-title {
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 38px;
    color: #3c585f;
  }
  .right-sidebar {
    width: 244px;
    background: #f6f8f9;
    border-radius: 8px;
    padding: 20px 24px 24px 24px;
  }
  .items {
    margin-bottom: 16px;
    a {
      p {
      }
      text-decoration: none;
      font-style: normal;
      font-weight: 600;
      font-size: 17px;
      line-height: 25px;
      color: #56787d;
    }
    display: flex;
    align-items: center;
  }
  .provider-grouping {
    width: 553px;
    margin-right: 31px;
    display: flex;
    flex-direction: column;
  }
  .contact-grouping {
    width: 238px;
    display: flex;
    flex-direction: column;
  }
  .contact {
    width: 276px;
    margin-bottom: 16px;
    margin-right: 31px;
    display: flex;
    flex-direction: column;
  }
  .contact-small {
    width: 238px;
    margin-right: 31px;
    display: flex;
    flex-direction: column;
  }
  .provider-container {
    margin-bottom: 24px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 546px;
  }
  .sub-header {
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 25px;
    color: #3c585f;
  }
  #providers {
    margin-bottom: 20px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #3c585f;
  }
  #providers-side {
    margin-bottom: 16px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #3c585f;
    a {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #3c585f;
    }
  }
  .title {
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 38px;
    color: #3c585f;
    padding-top: 24px;
    padding-bottom: 16px;
  }
  .title2 {
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 38px;
    color: #3c585f;
    padding-bottom: 16px;
  }
  .title3 {
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 38px;
    color: #3c585f;
    padding-bottom: 16px;
  }
  .header-title {
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 38px;
    color: #3c585f;
    padding-top: 24px;
    padding-bottom: 16px;
  }
  #browse {
    box-sizing: border-box;
    height: 34px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    letter-spacing: 0.01em;
    cursor: pointer;
    background: white;
    color: #56787d;
  }
  #browse.browse-link:hover {
    color: #ff4a6b !important;
  }
`

const TreatmentProvidersMegaMenu = ({ linkData }) => {
  return (
    <Style>
      {linkData?.name === 'Contact Us' && (
        <div className="header-title">
          <p>{linkData.header}</p>
        </div>
      )}
      <div
        className="center"
        style={{
          display: linkData?.name === 'Contact Us' ? 'flex' : 'block',
          width: linkData?.name === 'Contact Us' ? '545px' : 'auto'
        }}
      >
        {linkData?.name === 'Contact Us' ? (
          <>
            <div>
              <div className="title2">
                <p>{linkData?.subheader1}</p>
              </div>
              <div className="">
                <div className="contact-small">
                  <p id="providers-side">{linkData.text1 || linkData.text}</p>
                </div>
              </div>
              <div className="center-align flex">
                <a
                  href={`${linkData.link}`}
                  className="browse flex items-center !text-gray-800 hover:!text-gray-1100"
                >
                  {linkData.button}{' '}
                  <ChevronRight className="menu-caret ml-5 mt-0.5 size-4" />
                </a>
              </div>
            </div>
            <div style={{ maxWidth: '292px' }}>
              <div className="title2">
                <p>{linkData?.subheader2}</p>
              </div>
              <div className="">
                <div className="contact">
                  <p id="providers-side">
                    {linkData?.subheader2 === 'For Treatment Seekers' ? (
                      <span>
                        If you're looking for treatment, please{' '}
                        <a
                          href="/"
                          style={{
                            textDecoration: 'underline',
                            color: '#3c585f'
                          }}
                        >
                          browse the site
                        </a>{' '}
                        to reach out to treatment centers directly.
                      </span>
                    ) : (
                      `${linkData.text2}`
                    )}
                  </p>
                </div>
              </div>
              <div id="dialogs">
                <p>
                  If you need emergency assistance, please contact the following
                  helplines:
                </p>
                <div>
                  <ul style={{ display: 'flex', flexDirection: 'column' }}>
                    <li>911 or your local emergency number</li>
                    <li>
                      <a
                        id="link"
                        target={'_blank'}
                        href="https://www.samhsa.gov/find-help/helplines/national-helpline"
                        rel="noreferrer"
                      >
                        SAMHSA’s National Helpline
                      </a>{' '}
                      at 1-800-662-HELP (1-800-662-4357)
                    </li>
                    <li>
                      <a
                        id="link"
                        target={'_blank'}
                        href="https://988lifeline.org/"
                        rel="noreferrer"
                      >
                        988 Suicide & Crisis Lifeline
                      </a>{' '}
                      at 1-800-273-TALK (1-800-273-8255)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <div className="title">
                <p>{linkData?.subheader1 || linkData?.header}</p>
              </div>
              <div className="">
                <div className="provider-grouping">
                  <p id="providers">{linkData?.text1 || linkData?.text}</p>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <a
                  href={`${linkData?.link}`}
                  id="browse"
                  className="hover:!text-gray-1100"
                >
                  {linkData?.button}
                  <ChevronRight className="menu-caret ml-5 mt-0.5 size-4" />
                </a>
              </div>
            </div>
            <div>
              <div
                className="title"
                style={{ paddingTop: '32px' }}
              >
                <p>{linkData?.subheader2 || linkData?.header2}</p>
              </div>
              <div className="">
                <div className="provider-grouping">
                  <p id="providers">{linkData?.text2}</p>
                </div>
              </div>
              {linkData?.header2 && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <a
                    href={`${linkData?.link2}`}
                    id="browse"
                    className="hover:!text-gray-1100"
                  >
                    {linkData?.button2}
                    <ChevronRight className="menu-caret ml-5 mt-0.5 size-4" />
                  </a>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </Style>
  )
}

export default TreatmentProvidersMegaMenu
